import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { marker as _ } from '@vandres/ngx-translate-extract-marker';

export class PaginatorIntlService extends MatPaginatorIntl {
  translate: TranslateService;
  // itemsPerPageLabel = 'Items per page!';
  // nextPageLabel     = 'Next page!';
  // previousPageLabel = 'Previous page!';
  getRangeLabel = function(page, pageSize, length) {
    const ofWord = this.translate ? this.translate.instant(_('of')) : 'of';
    if (length === 0 || pageSize === 0) {
      return '0 ' + ofWord + ' ' + length;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    return startIndex + 1 + ' - ' + endIndex + ' ' + ofWord + ' ' + length;
  };

  injectTranslateService(translate: TranslateService) {
    this.translate = translate;

    this.translate.onLangChange.subscribe(() => {
      this.translateLabels();
    });

    this.translateLabels();
  }

  translateLabels() {
    this.itemsPerPageLabel = this.translate.instant(_('Items per page'));
    // this.nextPageLabel = this.translate.instant('Next page');
    // this.previousPageLabel = this.translate.instant('Previous page');
    this.changes.next();
  }

}
